/**
 * #1499 (design §6.1): an entity answer's one count line, from the rows THIS surface carries — never from the persisted
 * disclosure. The same words as the backend's `agent/landing/v1/entity_disclosure.showing` (a test holds them equal).
 */
export interface EntityDisclosureSnapshot {
  form: 'list' | 'count';
  returned: number;
  truncated: boolean;
  total: number | null;
}

const n = (v: number) => v.toLocaleString('en-US');

export function entityTotal(d: EntityDisclosureSnapshot): number | null {
  if (d.total !== null && d.total !== undefined) return d.total;
  return d.truncated ? null : d.returned;
}

export function entityShowing(d: EntityDisclosureSnapshot | undefined, carried: number): string | null {
  if (!d || d.form !== 'list') return null;
  const total = entityTotal(d);
  if (total === null) return `Showing ${n(carried)} of at least ${n(d.returned)} records.`;
  return `Showing ${n(carried)} of ${n(total)} records.`;
}

export function entitySnapshot(raw: unknown): EntityDisclosureSnapshot | undefined {
  if (!raw || typeof raw !== 'object') return undefined;
  const r = raw as Record<string, unknown>;
  if ((r.form !== 'list' && r.form !== 'count') || typeof r.returned !== 'number') return undefined;
  return { form: r.form, returned: r.returned, truncated: r.truncated === true,
           total: typeof r.total === 'number' ? r.total : null };
}
